import { FC } from "react";
import {
  Card,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  styled,
} from "@mui/material";
import { Question } from "../types";

const CalculatorQuestionContainer = styled(Card)({
  padding: "1rem",
});

interface QuestionCardProps {
  index: number;
  question: Question;
  responses?: { [key: string]: boolean | string | number };
  updateResponses: (
    questionId: string,
    value: string | number | boolean,
  ) => void;
}

const QuestionCard: FC<QuestionCardProps> = ({
  index,
  question: { questionId, question, additionalInfo, answerType, answers },
  responses,
  updateResponses,
}) => {
  return (
    <CalculatorQuestionContainer variant="outlined">
      <FormControl>
        <FormLabel id={`radio-buttons-calculator-question-${index}-label`}>
          {index}. {question}
        </FormLabel>
        <FormHelperText>{additionalInfo}</FormHelperText>
        {answerType === "number" ? (
          <TextField
            type="number"
            value={responses?.[questionId]}
            onChange={(e) =>
              updateResponses(questionId, parseInt(e.target.value))
            }
          />
        ) : (
          <RadioGroup
            row
            aria-labelledby={`radio-buttons-calculator-question-${index}-label`}
            name={`radio-buttons-calculator-question-${index}`}
            value={responses?.[questionId] ? responses[questionId] : undefined}
            onChange={(e) =>
              updateResponses(
                questionId,
                answerType === "boolean"
                  ? e.target.value === "true"
                  : e.target.value,
              )
            }
          >
            {answers.map(({ value, patientDisplay }) => (
              <FormControlLabel
                key={`${questionId}-${value}`}
                value={value}
                control={<Radio />}
                label={patientDisplay}
              />
            ))}
          </RadioGroup>
        )}
      </FormControl>
    </CalculatorQuestionContainer>
  );
};

export default QuestionCard;
